import '../../../styles/footer.css'
const Footer = () => {
    return ( 
        <footer>
            {/* <nav>
                <a href="#">FAQs</a>
                <a href="#">Get Coupon Code</a>
                <a href="#">Home</a>
            </nav> */}
        </footer>
     );
}
 
export default Footer;